import React, { useEffect } from 'react';
import { ChevronRight, Phone, AlertTriangle, Package, FileText, Clock } from 'lucide-react';
export function ReturnsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <section className="bg-cream" data-id="element-877">
      {/* Page Header */}
      <div className="bg-cream-dark border-b border-warmBorder" data-id="element-878">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14" data-id="element-879">
          <nav className="flex items-center gap-2 text-sm text-warmGray mb-4" data-id="element-880">
            <a href="#/" className="hover:text-gold transition-colors" data-id="element-881">
              Home
            </a>
            <ChevronRight size={14} className="text-warmGray/50" data-id="element-882" />
            <span className="text-charcoal font-medium" data-id="element-883">
              Returns &amp; Exchanges
            </span>
          </nav>
          <h1 className="text-3xl md:text-4xl font-serif text-charcoal" data-id="element-884">
            Returns &amp; Exchanges
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-885">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16" data-id="element-886">
          {/* Main Content */}
          <div className="lg:w-2/3 space-y-8" data-id="element-887">
            {/* Quick Summary */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-888">
              <div className="bg-white p-6 rounded-sm border border-warmBorder text-center" data-id="element-889">
                <div className="w-10 h-10 mx-auto bg-gold/10 rounded-full flex items-center justify-center mb-3" data-id="element-890">
                  <Clock className="w-5 h-5 text-gold" data-id="element-891" />
                </div>
                <h3 className="font-bold text-charcoal text-sm mb-1" data-id="element-892">
                  30-Day Window
                </h3>
                <p className="text-warmGray text-xs leading-relaxed" data-id="element-893">
                  From original shipping date
                </p>
              </div>
              <div className="bg-white p-6 rounded-sm border border-warmBorder text-center" data-id="element-894">
                <div className="w-10 h-10 mx-auto bg-gold/10 rounded-full flex items-center justify-center mb-3" data-id="element-895">
                  <FileText className="w-5 h-5 text-gold" data-id="element-896" />
                </div>
                <h3 className="font-bold text-charcoal text-sm mb-1" data-id="element-897">
                  RA Number Required
                </h3>
                <p className="text-warmGray text-xs leading-relaxed" data-id="element-898">
                  Call us to get your number
                </p>
              </div>
              <div className="bg-white p-6 rounded-sm border border-warmBorder text-center" data-id="element-899">
                <div className="w-10 h-10 mx-auto bg-gold/10 rounded-full flex items-center justify-center mb-3" data-id="element-900">
                  <Package className="w-5 h-5 text-gold" data-id="element-901" />
                </div>
                <h3 className="font-bold text-charcoal text-sm mb-1" data-id="element-902">
                  Original Packaging
                </h3>
                <p className="text-warmGray text-xs leading-relaxed" data-id="element-903">
                  Must be unopened &amp; uninstalled
                </p>
              </div>
            </div>

            {/* Return Policy */}
            <div className="bg-white p-8 md:p-10 rounded-sm shadow-sm border border-warmBorder" data-id="element-904">
              <h2 className="text-2xl font-serif text-charcoal mb-6" data-id="element-905">
                Return Policy
              </h2>
              <div className="space-y-5 text-warmGray leading-relaxed" data-id="element-906">
                <p data-id="element-907">
                  Returns or exchanges are accepted for up to{' '}
                  <strong className="text-charcoal" data-id="element-908">30 days</strong> from the
                  original shipping date.
                </p>
                <p data-id="element-909">
                  All returns or exchanges must have a{' '}
                  <strong className="text-charcoal" data-id="element-910">
                    Return Authorization Number
                  </strong>
                  . Just call us at{' '}
                  <a href="tel:13046863170" className="text-gold hover:text-gold-dark font-bold transition-colors" data-id="element-911">
                    1-304-686-3170
                  </a>
                  , Monday–Friday, 9AM–5PM EST.
                </p>
                <p data-id="element-912">
                  Returns must include a copy of the original invoice so we can
                  credit the proper account or have the correct address in the
                  case of an exchange.
                </p>
              </div>
            </div>

            {/* Important Conditions */}
            <div className="bg-white p-8 md:p-10 rounded-sm shadow-sm border border-warmBorder" data-id="element-913">
              <div className="flex items-center gap-3 mb-6" data-id="element-914">
                <AlertTriangle className="w-6 h-6 text-terracotta flex-shrink-0" data-id="element-915" />
                <h2 className="text-2xl font-serif text-charcoal" data-id="element-916">
                  Important Conditions
                </h2>
              </div>
              <div className="space-y-5 text-warmGray leading-relaxed" data-id="element-917">
                <div className="bg-terracotta/5 border border-terracotta/20 p-5 rounded-sm" data-id="element-918">
                  <p data-id="element-919">
                    Switchplates{' '}
                    <strong className="text-charcoal" data-id="element-920">
                      MUST BE IN THE ORIGINAL PACKAGING AND NEVER INSTALLED
                    </strong>
                    . There are{' '}
                    <strong className="text-charcoal" data-id="element-921">NO RETURNS</strong> for
                    Special Order Configurations, custom orders, installed
                    switchplates, or customer-damaged switchplates.
                  </p>
                </div>
                <p data-id="element-922">
                  Refunds or exchanges will not be given for any switchplate
                  that has been installed or appears to have been installed. Our
                  packaging is crystal clear, which enables you to determine if
                  the wrong size switchplate was ordered or the colors don't
                  match your decorating theme.
                </p>
                <p data-id="element-923">We do not refund shipping and handling charges.</p>
                <p data-id="element-924">
                  For exchanges due to wrong color ordered, wrong size or
                  configuration ordered, etc.,
                  <strong className="text-charcoal" data-id="element-925">
                    {' '}
                    standard shipping and handling charges will apply
                  </strong>
                  . If we make an error on your order then we will ship you the
                  correct item(s) at our expense.
                </p>
              </div>
            </div>

            {/* How to Return */}
            <div className="bg-white p-8 md:p-10 rounded-sm shadow-sm border border-warmBorder" data-id="element-926">
              <h2 className="text-2xl font-serif text-charcoal mb-6" data-id="element-927">
                How to Return
              </h2>
              <div className="space-y-5 text-warmGray leading-relaxed" data-id="element-928">
                <p data-id="element-929">
                  You may exchange for a different size or design, or receive a
                  full refund,
                  <strong className="text-charcoal" data-id="element-930">
                    {' '}
                    MINUS SHIPPING AND HANDLING COSTS
                  </strong>
                  . Include a copy of the original invoice along with any items
                  you wish to return to:
                </p>
                <div className="bg-cream-dark p-5 rounded-sm border border-warmBorder" data-id="element-931">
                  <p className="font-bold text-charcoal" data-id="element-932">
                    Switchplate Gallery LLC
                  </p>
                  <p data-id="element-933">44 Granny's Lookout Loop</p>
                  <p data-id="element-934">Cameron, WV 26033</p>
                </div>
                <p data-id="element-935">
                  Please include a way to contact you if needed, such as a
                  telephone number and/or email address in case of questions.
                </p>
              </div>
            </div>

            {/* Packaging Instructions */}
            <div className="bg-white p-8 md:p-10 rounded-sm shadow-sm border border-warmBorder" data-id="element-936">
              <h2 className="text-2xl font-serif text-charcoal mb-6" data-id="element-937">
                Packaging Instructions
              </h2>
              <div className="space-y-5 text-warmGray leading-relaxed" data-id="element-938">
                <p data-id="element-939">
                  Our switchplates are steel and will not break — but we have
                  received returns that have been bent in the mail! Please
                  package any returns sufficiently to prevent damage. We cannot
                  issue credit for switchplates damaged due to negligent
                  packaging.
                </p>
                <ul className="space-y-3" data-id="element-940">
                  <li className="flex items-start gap-3" data-id="element-941">
                    <span className="w-2 h-2 rounded-full bg-gold mt-2 flex-shrink-0" data-id="element-942" />
                    <span data-id="element-943">
                      Returns should be packaged so there are no loose screws —
                      they should be taped to the back of the switchplate.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-944">
                    <span className="w-2 h-2 rounded-full bg-gold mt-2 flex-shrink-0" data-id="element-945" />
                    <span data-id="element-946">
                      When packing multiple switchplates, ensure the screws from
                      the adjacent switchplate do not rub against the face of
                      the other switchplate.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-947">
                    <span className="w-2 h-2 rounded-full bg-gold mt-2 flex-shrink-0" data-id="element-948" />
                    <span data-id="element-949">
                      Padded envelopes should be marked{' '}
                      <strong className="text-charcoal" data-id="element-950">
                        "HAND CANCEL ONLY"
                      </strong>
                      .
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact CTA */}
            <div className="bg-charcoal text-cream p-8 md:p-10 rounded-sm" data-id="element-951">
              <h3 className="text-2xl font-serif text-white mb-3" data-id="element-952">
                Need Help With a Return?
              </h3>
              <p className="text-warmGray-light leading-relaxed mb-6" data-id="element-953">
                If you need help or have any questions, please give us a call.
                We are very easy to get along with, and will do all we can to
                ensure that you are delighted with your switchplates. We want
                you to be glad you ordered from Switchplate Gallery!
              </p>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-954">
                <a href="tel:13046863170" className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-gold hover:bg-gold-light text-white font-bold rounded-sm transition-colors text-sm" data-id="element-955">
                  <Phone size={16} data-id="element-956" />
                  1-304-686-3170
                </a>
                <a href="#/contact" className="inline-flex items-center justify-center px-8 py-3.5 bg-white/10 border border-white/20 text-white hover:bg-white/20 font-bold rounded-sm transition-colors text-sm" data-id="element-957">
                  Contact Us Online
                </a>
              </div>
              <p className="text-warmGray-light text-sm mt-4" data-id="element-958">
                Monday–Friday, 9AM–5PM EST
              </p>
            </div>
          </div>

          {/* Sidebar */}
          <div className="lg:w-1/3" data-id="element-959">
            <div className="bg-white p-8 rounded-sm border border-warmBorder sticky top-32 shadow-warm" data-id="element-960">
              <h4 className="font-serif text-xl text-charcoal mb-6 border-b border-warmBorder pb-4" data-id="element-961">
                Quick Reference
              </h4>
              <ul className="space-y-4 text-sm text-warmGray" data-id="element-962">
                <li className="flex items-start gap-3" data-id="element-963">
                  <span className="w-2 h-2 rounded-full bg-gold mt-1.5 flex-shrink-0" data-id="element-964" />
                  <span data-id="element-965">
                    <strong className="text-charcoal" data-id="element-966">30 days</strong> from
                    shipping date
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-967">
                  <span className="w-2 h-2 rounded-full bg-gold mt-1.5 flex-shrink-0" data-id="element-968" />
                  <span data-id="element-969">
                    <strong className="text-charcoal" data-id="element-970">RA Number</strong>{' '}
                    required for all returns
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-971">
                  <span className="w-2 h-2 rounded-full bg-gold mt-1.5 flex-shrink-0" data-id="element-972" />
                  <span data-id="element-973">
                    <strong className="text-charcoal" data-id="element-974">
                      Original packaging
                    </strong>{' '}
                    — never installed
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-975">
                  <span className="w-2 h-2 rounded-full bg-gold mt-1.5 flex-shrink-0" data-id="element-976" />
                  <span data-id="element-977">
                    <strong className="text-charcoal" data-id="element-978">Include invoice</strong>{' '}
                    with your return
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-979">
                  <span className="w-2 h-2 rounded-full bg-terracotta mt-1.5 flex-shrink-0" data-id="element-980" />
                  <span data-id="element-981">
                    <strong className="text-charcoal" data-id="element-982">No returns</strong> on
                    custom/special orders
                  </span>
                </li>
              </ul>

              <div className="mt-8 pt-6 border-t border-warmBorder" data-id="element-983">
                <h4 className="font-serif text-lg text-charcoal mb-4" data-id="element-984">
                  Helpful Links
                </h4>
                <ul className="space-y-3" data-id="element-985">
                  <li data-id="element-986">
                    <a href="#/shipping" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group text-sm" data-id="element-987">
                      <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-988" />
                      Shipping Information
                    </a>
                  </li>
                  <li data-id="element-989">
                    <a href="#/faq" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group text-sm" data-id="element-990">
                      <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-991" />
                      FAQ &amp; "How To" Info
                    </a>
                  </li>
                  <li data-id="element-992">
                    <a href="#/contact" className="flex items-center text-warmGray hover:text-gold transition-colors font-medium group text-sm" data-id="element-993">
                      <span className="w-2 h-2 rounded-full bg-gold/50 mr-3 group-hover:bg-gold transition-colors" data-id="element-994" />
                      Contact Us
                    </a>
                  </li>
                </ul>
              </div>

              <div className="mt-8 pt-6 border-t border-warmBorder" data-id="element-995">
                <p className="text-sm text-warmGray mb-2 uppercase tracking-wider font-bold" data-id="element-996">
                  Get an RA Number
                </p>
                <a href="tel:13046863170" className="text-2xl font-serif text-gold hover:text-gold-dark transition-colors" data-id="element-997">
                  304.686.3170
                </a>
                <p className="text-xs text-warmGray mt-1" data-id="element-998">
                  Mon–Fri, 9AM–5PM EST
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}